import { FC } from 'react'

import style from './ControlPreventionItem.module.css';

type ControlPreventionItemProps = {
  className?: string,
  article: any,
  index: number,
  isPreview?: boolean
}

const ControlPreventionItem:FC<ControlPreventionItemProps> = ({ className = '', article, index, isPreview = false  }) => {

  let postContentJson: any = {};
  try {
    if (article?.html) {
      postContentJson = JSON.parse(article.html);
    }
  } catch (error) {
    console.log(`Article format: ${article.id}`);
    return null;
  }

  const {postButtonText, postImagePosition, postImageUrl, postText, postTitle, postUrl, postWidth} = postContentJson;
  
  return (
    <>
      {
        isPreview ?
          <div className={style.previewPostContainer}>
            <div
              key={postTitle ? postTitle : 'editing'}
              className={`
                ${style.post} 
                ${postWidth === 'full' ? style.fullWidth : style.halfWidth}
                ${postImagePosition === 'left' && style.postFlex}
              `}
            >
              {postImageUrl &&  
                <div className={`${style.post__image}`}>
                  <img src={postImageUrl} alt={postTitle ? postTitle : 'Nota INDISA'} />
                </div>
              }

              <div className={style.post__content}>
                <h3 className={style.post__title}>{postTitle}</h3>
                <p className={style.post__text}>{postText}</p>

                {
                  postButtonText && postButtonText !== '' && postUrl ?
                  <div className={style.post__buttonContainer}>
                    <a
                      href={postUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={style.post__button}
                    >
                      {postButtonText}
                    </a>
                  </div>
                  : null
                }
                
              </div>

            </div>
            {postWidth === 'half' && <div></div>}
          </div>


          : 
          <div
            className={`
              ${style.post} 
              ${postWidth === 'full' ? style.fullWidth : style.halfWidth}
              ${postImagePosition === 'left' && style.postFlex}
            `}
          >
            {postImageUrl &&  
              <div className={`${style.post__image}`}>
                <img src={postImageUrl} alt={postTitle ? postTitle : 'Nota INDISA'} />
              </div>
            }

            <div className={style.post__content}>
              <h3 className={style.post__title}>{postTitle}</h3>
              <p className={style.post__text}>{postText}</p>

              {
                postButtonText && postButtonText !== '' && postUrl ?
                <div className={style.post__buttonContainer}>
                  <a
                    href={postUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={style.post__button}
                  >
                    {postButtonText}
                  </a>
                </div>
                : null
              }
              
            </div>
          </div>
      }
    </>
  )
}

export { ControlPreventionItem }